export const drawer = {
    slots: {
        title: 'text-2xl',
        body: 'text-neutral-700 text-sm',
    },
}
